<template>
    <div id="config-rattachment">
        <FilterView placeholder="Chercher une session de rattachement..." v-model="searchTerm">
            <CustomButton
                v-if="selected.length"
                icon="trash-alt"
                class="default red-theme"
                @click="showConfirmMany = true"
                >Supprimer</CustomButton
            >
            <CustomButton icon="plus" class="default green-theme" @click="handleNew"
                >Créer une session de rattachement</CustomButton
            >
        </FilterView>
        <ModalRattachment
            v-if="showEdit"
            v-model="rattachment"
            @dismiss="showEdit = false"
            @close="handleClose"
        />
        <ModalRattachmentLoading v-if="loadingModalMessage" v-model="loadingModalMessage" />
        <ModalRattachmentMessage
            v-if="messageModalMessage"
            v-model="messageModalMessage"
            v-bind:header="headerModalMessage"
            v-bind:body="bodyModalMessage"
            v-bind:error="errorModalMessage"
            v-bind:footer="footerModalMessage"
            @dismiss="messageModalMessage = null"
        />
        <Confirm v-if="showConfirmOne" @dismiss="showConfirmOne = false" @close="handleDeleteOne">
            <span slot="header">Supprimer la session de rattachement</span>
            <span slot="body"
                >Êtes-vous sûr de vouloir supprimer cette session de rattachement ?</span
            >
        </Confirm>
        <Confirm
            v-if="showConfirmMany"
            @dismiss="showConfirmMany = false"
            @close="handleDeleteMany"
        >
            <span slot="header">Supprimer {{ selected.length }} session(s) de rattachement</span>
            <span slot="body"
                >Êtes-vous sûr de vouloir supprimer toutes les sessions de rattachement
                sélectionnées ?</span
            >
        </Confirm>
        <CloseConfirm
            v-if="showCloseConfirm"
            @dismiss="showCloseConfirm = false"
            @close="handleCloseSession"
        >
            <span slot="header">Clore la session de rattachement</span>
            <span slot="body">Êtes-vous sûr de vouloir clore cette session de rattachement ?</span>
        </CloseConfirm>

        <AutomaticRattachmentConfirm
            v-if="showAutomaticRattachmentConfirm"
            @dismiss="showAutomaticRattachmentConfirm = false"
            @close="handleAutomaticRattachmentSession"
        >
            <span slot="header">Exécuter le rattachement automatique</span>
            <span slot="body"
                >Êtes-vous sûr de vouloir lancer le rattachement automatique pour cette session de
                rattachement ?</span
            >
        </AutomaticRattachmentConfirm>

        <h2 class="title">Sessions de rattachement classique</h2>
        <LoadingDots v-if="isLoading" />
        <CardPager :pagination="false">
            <RattachmentCard
                v-for="item in filtered"
                :item="item"
                :key="item.id"
                :handleDuplicate="handleDuplicate"
                :handleEdit="handleEdit"
                :handleConfirm="handleConfirm"
                :handleCloseConfirm="handleCloseConfirm"
                :handleAutomaticRattachmentConfirm="handleAutomaticRattachmentConfirm"
                :selected="selected"
                @selected="handleSelect"
            />
        </CardPager>

        <h2 class="title">Sessions de rattachement inverse</h2>
        <LoadingDots v-if="isLoading" />
        <CardPager :pagination="false">
            <RattachmentCard
                v-for="item in filteredInverse"
                :item="item"
                :key="item.id"
                :handleDuplicate="handleDuplicate"
                :handleEdit="handleEdit"
                :handleConfirm="handleConfirm"
                :handleCloseConfirm="handleCloseConfirm"
                :handleAutomaticRattachmentConfirm="handleAutomaticRattachmentConfirm"
                :selected="selected"
                @selected="handleSelect"
            />
        </CardPager>
    </div>
</template>

<script>
import FilterView from '@/components/config/Filter';
import ModalRattachment from '@/components/config/ModalRattachment';
import ModalRattachmentLoading from '@/components/config/ModalRattachmentLoading';
import ModalRattachmentMessage from '@/components/config/ModalRattachmentMessage';
import Confirm from '@/components/config/DeleteConfirm';
import CloseConfirm from '@/components/config/CloseConfirm';
import AutomaticRattachmentConfirm from '@/components/config/AutomaticRattachmentConfirm';
import CustomButton from '@/components/Button';
import LoadingDots from '@/components/LoadingDots';
import CardPager from '@/components/CardPager';
import RattachmentCard from '@/components/config/RattachmentCard';

export default {
    data() {
        return {
            showEdit: false,
            showConfirmOne: false,
            showConfirmMany: false,
            showCloseConfirm: false,
            showAutomaticRattachmentConfirm: false,
            rattachments: [],
            rattachment: null,
            searchTerm: null,
            isLoading: true,
            selected: [],
            loadingModalMessage: null,
            messageModalMessage: null,
        };
    },
    computed: {
        filtered() {
            if (this.searchTerm) {
                const re = new RegExp(this.searchTerm, 'i');
                return this.rattachments
                    .filter((r) => r.isinverse !== true)
                    .filter((r) => re.test(r.name));
            }
            return this.rattachments.filter((r) => r.isinverse !== true);
        },
        filteredInverse() {
            if (this.searchTerm) {
                const re = new RegExp(this.searchTerm, 'i');
                return this.rattachments
                    .filter((r) => r.isinverse === true)
                    .filter((r) => re.test(r.name));
            }
            return this.rattachments.filter((r) => r.isinverse === true);
        },
    },
    mounted() {
        this._getRattachments();
    },
    methods: {
        _getRattachments() {
            return new Promise((resolve, reject) => {
                this.isLoading = true;
                this.rattachments = [];
                this.$http.get('/api/rattachment').then(
                    (response) => {
                        // success callback
                        this.rattachments = response.body;
                        this.isLoading = false;
                        resolve();
                    },
                    (response) => {
                        // error callback
                        this.isLoading = false;
                        console.error(response);
                        reject();
                    },
                );
            });
        },
        _getRattachment(id) {
            const rattachment = this.rattachments.find((r) => r.id === id);
            return {
                ...rattachment,
            };
        },
        handleSelect(event) {
            const { id, checked } = event;
            const index = this.selected.findIndex((s) => s === id);
            if (checked) {
                if (index === -1) {
                    this.selected.push(id);
                }
            } else {
                if (index > -1) {
                    this.selected.splice(index, 1);
                }
            }
        },
        handleConfirm(item) {
            this.rattachment = this._getRattachment(item);
            this.showConfirmOne = true;
        },
        handleCloseConfirm(item) {
            this.rattachment = this._getRattachment(item);
            this.showCloseConfirm = true;
        },
        handleAutomaticRattachmentConfirm(item) {
            this.rattachment = this._getRattachment(item);
            this.showAutomaticRattachmentConfirm = true;
        },
        handleEdit(item) {
            this.$router.push({ name: 'rattachmentedit', params: { form: 'update', id: item } });
        },
        handleDuplicate(item) {
            this.$router.push({
                name: 'rattachmentduplicate',
                params: { form: 'duplicate', id: item },
            });
        },
        handleClose() {
            if (
                !this.rattachment.id &&
                this.rattachment.name &&
                this.rattachment.host &&
                this.rattachment.port &&
                this.rattachment.db &&
                this.rattachment.tablefil &&
                this.rattachment.tablefil_attr &&
                this.rattachment.tableattr &&
                this.rattachment.tablegeom &&
                this.rattachment.schema_temp &&
                this.rattachment.fid &&
                this.rattachment.fgeom &&
                this.rattachment.flist &&
                this.rattachment.tolerance &&
                this.rattachment.epsg
            ) {
                this.showEdit = false;
                this.loadingModalMessage = 'Initialisation de la session de rattachement en cours…';

                this.$http
                    .post('/api/rattachment', this.rattachment)
                    .then(() => {
                        this._getRattachments().then(() => {
                            this.showEdit = false;
                            this.rattachment = null;
                            this.loadingModalMessage = null;
                        });
                    })
                    .catch((err) => {
                        this.loadingModalMessage = null;
                        this.messageModalMessage = 'Erreur';
                        this.headerModalMessage =
                            'Erreur lors de la création\nde la session de rattachement';
                        this.bodyModalMessage = null;
                        this.errorModalMessage = `Statut : ${err.statusText}\nNom : ${
                            err.body.error.name
                        }\nCode : ${err.body.error.original.code}\nRoutine : ${
                            err.body.error.original.routine
                        }`;
                        this.footerModalMessage = null;
                        this.showEdit = true;
                    });
            } else if (
                this.rattachment.id &&
                this.rattachment.name &&
                this.rattachment.host &&
                this.rattachment.port &&
                this.rattachment.db &&
                this.rattachment.flist &&
                this.rattachment.tolerance
            ) {
                this.$http
                    .put(`/api/rattachment/${this.rattachment.id}`, this.rattachment)
                    .then((response) => {
                        const rattachment = response.body;
                        const index = this.rattachments.findIndex((r) => r.id === rattachment.id);
                        this.rattachments.splice(index, 1, rattachment);
                        this.showEdit = false;
                        this.rattachment = null;
                    })
                    .catch();
            }
        },
        handleNew() {
            this.$router
                .push({ name: 'rattachmentinsert', params: { form: 'insert' } })

                .catch((err) => {
                    this.loadingModalMessage = null;
                    this.messageModalMessage = 'Erreur';
                    this.headerModalMessage =
                        'Erreur lors de la création\nde la session de rattachement';
                    this.bodyModalMessage = null;
                    this.errorModalMessage = `Statut : ${err.statusText}\nNom : ${
                        err.body.error.name
                    }\nCode : ${err.body.error.original.code}\nRoutine : ${
                        err.body.error.original.routine
                    }`;
                    this.footerModalMessage = null;
                })
                .finally(() => (this.isLoading = false));
        },
        handleDeleteOne() {
            this.loadingModalMessage = 'Suppression de la session de rattachement en cours…';
            this.showConfirmOne = false;
            this.$http
                .delete(`/api/rattachment/${this.rattachment.id}`)
                .then(() => {
                    this._getRattachments().then(() => {
                        this.rattachment = null;
                        this.loadingModalMessage = null;
                    });
                })
                .catch((err) => {
                    this.loadingModalMessage = null;
                    this.messageModalMessage = 'Erreur';
                    this.headerModalMessage =
                        'Erreur lors de la suppression\nde la session de rattachement';
                    this.bodyModalMessage = null;
                    this.errorModalMessage = `Statut : ${err.statusText}\nNom : ${
                        err.body.error.name
                    }\nCode : ${err.body.error.original.code}\nRoutine : ${
                        err.body.error.original.routine
                    }`;
                    this.footerModalMessage = null;
                })
                .finally(() => (this.isLoading = false));
        },
        handleDeleteMany() {
            this.loadingModalMessage = 'Suppression des sessions de rattachement en cours…';
            this.showConfirmMany = false;
            const requests = this.selected.map((s) => this.$http.delete(`/api/rattachment/${s}`));
            Promise.all(requests)
                .then(() => {
                    this.selected.splice(0);
                    this.isLoading = true;
                    return this.$http.get('/api/rattachment');
                })
                .then((response) => {
                    // success callback
                    this.rattachments = response.body;
                    this.loadingModalMessage = null;
                })
                .catch((err) => {
                    this.loadingModalMessage = null;
                    this.messageModalMessage = 'Erreur';
                    this.headerModalMessage =
                        'Erreur lors de la suppression\ndes sessions de rattachement';
                    this.bodyModalMessage = null;
                    this.errorModalMessage = `Statut : ${err.statusText}\nNom : ${
                        err.body.error.name
                    }\nCode : ${err.body.error.original.code}\nRoutine : ${
                        err.body.error.original.routine
                    }`;
                    this.footerModalMessage = null;
                })
                .finally(() => (this.isLoading = false));
        },
        handleCloseSession() {
            // Ici le code à exécuter lorsqu'une session est close

            this.loadingModalMessage = 'Clôture de la session de rattachement en cours…';
            this.showCloseConfirm = false;

            // On passe le booléen isclosed à true
            this.rattachment.isclosed = true;

            // On envoie les modifications
            if (this.rattachment.id) {
                this.$http
                    .put(`/api/rattachment/${this.rattachment.id}`, this.rattachment)
                    .then(() => {
                        this._getRattachments().then(() => {
                            this.showCloseConfirm = false;
                            this.rattachment = null;
                            this.loadingModalMessage = null;
                        });
                    })
                    .catch((err) => {
                        this.loadingModalMessage = null;
                        this.messageModalMessage = 'Erreur';
                        this.headerModalMessage =
                            'Erreur lors de la clôture\nde la session de rattachement';
                        this.bodyModalMessage = null;
                        this.errorModalMessage = `Statut : ${err.statusText}\nNom : ${
                            err.body.error.name
                        }\nCode : ${err.body.error.original.code}\nRoutine : ${
                            err.body.error.original.routine
                        }`;
                        this.footerModalMessage = null;
                    })
                    .finally(() => (this.isLoading = false));
            }
        },
        handleAutomaticRattachmentSession() {
            // Ici le code à exécuter pour le rattachement automatique

            this.loadingModalMessage =
                'Rattachement automatique en cours…\nCela peut prendre plusieurs minutes.';
            this.showAutomaticRattachmentConfirm = false;

            if (this.rattachment.id) {
                this.$http
                    .put(`/api/rattachment/${this.rattachment.id}/vacuum`, this.rattachment)
                    .then(() => {
                        return this.$http.put(
                            `/api/rattachment/${this.rattachment.id}/automatic`,
                            this.rattachment,
                        );
                    })
                    .then((response) => {
                        this._getRattachments().then(() => {
                            let countRattach = response.body[0].totalrattachment;
                            let countTotal = response.body[1].total;
                            let diff = countTotal - countRattach;
                            let percentRattach =
                                Math.round((countRattach / countTotal) * 10000) / 100;
                            let percentToRattach = Math.round((diff / countTotal) * 10000) / 100;
                            this.showAutomaticRattachmentConfirm = false;
                            this.rattachment = null;
                            this.loadingModalMessage = null;
                            this.messageModalMessage = 'Terminé';
                            this.headerModalMessage = 'Le rattachement automatique est terminé';
                            this.bodyModalMessage = null;
                            this.errorModalMessage = `${countRattach} objet(s) rattaché(s) sur ${countTotal} (${percentRattach}%).\nIl reste ${diff} objet(s) à rattacher (${percentToRattach}%).`;
                            this.footerModalMessage = null;
                        });
                    })
                    .catch((err) => {
                        this.loadingModalMessage = null;
                        this.messageModalMessage = 'Erreur';
                        this.headerModalMessage = 'Erreur lors du rattachement automatique';
                        this.bodyModalMessage = null;
                        this.errorModalMessage = `Statut : ${err.statusText}\nNom : ${
                            err.body.error.name
                        }\nCode : ${err.body.error.original.code}\nRoutine : ${
                            err.body.error.original.routine
                        }`;
                        this.footerModalMessage = null;
                    })
                    .finally(() => (this.isLoading = false));
            }
        },
    },

    components: {
        ModalRattachment,
        ModalRattachmentLoading,
        ModalRattachmentMessage,
        Confirm,
        CloseConfirm,
        AutomaticRattachmentConfirm,
        CustomButton,
        FilterView,
        LoadingDots,
        CardPager,
        RattachmentCard,
    },
};
</script>

<style lang="scss"></style>
